export default __webpack_public_path__ + "static/media/illustration-health-3-w.a836dcdb.webp";